const qualityDefaultLimits = {
    maxFormNameLength: 250,
    maxQuestionGroupNameLength: 250,
    maxQuestionNameLength: 500,
    maxHelpTextLength: 500,
    maxAnswerTextLength: 500,
    maxExplanationPromptLength: 500,
    initMaxResponseCharacters: 250,
    maxResponseCharacters: 999,
    minResponseCharacters: 1,
    maxAssistanceConditionTopics: 10,
    maxAnswerOptionPoints: 100,
    maxCriticalAnswerOptionCount: 2,
    minAnswerOptionCount: 2,
    maxAnswerOptionCount: 20,
    maxAIScoringAnswerOptionCount: 3,
    maxAIScoringAnswerOptionCountV2: 5,
    minMultipleSelectQuestionOptionCount: 1,
    maxQuestionCount: 200,
    maxQuestionGroupScalingFactor: 999999,
    releaseDateExpiry: 45,
    scoringExpiry: 45,
    disputeExpiry: 45,
    deletingExpiry: 90,
    agentReviewExpiry: 90,
    maxDisputesPerEvaluation: 5,
    defaultDisputesPerEvaluation: 2,
    minDisputesPerEvaluation: 1,
    maxPassPercent: 100,
    minPassPercent: 0,
    maxScalingFactor: 999999,
    maxPermissibleQuestionsWithAiScoring: 15,
    maxPermissibleQuestionsWithAiScoringV2: 20,
    maxJavaInt32: 2147483647,
};

const scorableDefaultLimits = {
    generalCommentCharLimit: 5000,
};

export const DefaultLimits = Object.freeze({
    ...qualityDefaultLimits,
    ...scorableDefaultLimits,
});
